import { selectIsUnderwriter } from '@ps20-frontend/selector';
import { getAllUwContexts, selectUwEntries } from '@ps20-frontend/uw';
import { IAppState } from '../appState';
import { WarenkorbAngebot } from '../reducers/produkte.reducer';
import { hasUnderwriterInfo } from './warenkorb.selector';

export const selectShouldShowUwRejectionWarning = (state: IAppState): boolean => {
  if (selectIsUnderwriter(state)) {
    return false;
  }

  return state.warenkorb.some((produkt: WarenkorbAngebot) => {
    if (!hasUnderwriterInfo(produkt)) {
      return false;
    }

    return getAllUwContexts().some(descriptor => {
      const entry = selectUwEntries(produkt.uw, descriptor.key).find(
        candidate => candidate.isRequired,
      );
      return entry?.willUnderwrite === false && descriptor.isBlockingRisk?.(produkt) === true;
    });
  });
};

export function hasExtremwetterschutzBaustein(produkt: WarenkorbAngebot): boolean {
  return (
    produkt.selectedZusatzoptionen?.some(
      zusatzoption => zusatzoption.id === 'weitereNaturgefahren',
    ) ?? false
  );
}
